<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('certificate_centers_certificate')"
                        :isNewButton="checkPermission('certificatecentercertificate_store')"
                        :isColumns="true"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('certificate_centers_certificate')"
                              :isNewButton="checkPermission('certificatecentercertificate_store')"
                              :isColumns="true"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
            >
                <b-row>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('certificates_name')">
                            <b-form-input v-model="datatable.queryParams.filter.name"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('document_type')">
                            <parameter-selectbox v-model="datatable.queryParams.filter.document_type" :code="'certificate_document_types'" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('document_draft')">
                            <parameter-selectbox v-model="datatable.queryParams.filter.document_template" :code="'certificate_templates'" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('certificatecentercertificate_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificatecentercertificate_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificatecentercertificate_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
            <CommonModal ref="updateSignerModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificatecentercertificate_updatesigners')">
                <template v-slot:CommonModalTitle>
                    {{ $t('signers').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <signer-update :formId="formId"
                                 @updateSignerSuccess="updateSignerSuccess"
                                 v-if="formProcess=='signerUpdate'"/>
                </template>
            </CommonModal>
            <CommonModal ref="updateOtherSignerModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificatecentercertificate_updateothersigners')">
                <template v-slot:CommonModalTitle>
                    {{ $t('other_signers').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <other-signer-update :formId="formId"
                                 @updateOtherSignerSuccess="updateOtherSignerSuccess"
                                 v-if="formProcess=='otherSignerUpdate'"/>
                </template>
            </CommonModal>
            <CommonModal ref="updateLogoModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificatecentercertificate_addlogo')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit_logo').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <logo-update :formId="formId"
                                 v-if="formProcess=='logoUpdate'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Page
    import CreateForm from './CreateForm'
    import ShowForm from './ShowForm'
    import UpdateForm from './UpdateForm'
    import SignerUpdate from './SignerUpdate'
    import OtherSignerUpdate from './OtherSignerUpdate'
    import LogoUpdate from './LogoUpdate'

    //Service
    import CertificateCenterCertificateService from '@/services/CertificateCenterCertificateService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            ShowForm,
            UpdateForm,
            SignerUpdate,
            OtherSignerUpdate,
            LogoUpdate
        },
        metaInfo() {
            return {
                title: this.$t('certificate_centers_certificate')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'certificatecentercertificate_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'certificatecentercertificate_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('signers'),
                                    class: 'ri-edit-box-line',
                                    permission: 'certificatecentercertificate_updatesigners',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadSignerData();
                                    }
                                },
                                {
                                    text: this.$t('other_signers'),
                                    class: 'ri-edit-box-line',
                                    permission: 'certificatecentercertificate_updateothersigners',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadOtherSignerData();
                                    }
                                },
                                {
                                    text: this.$t('edit_logo'),
                                    class: 'ri-edit-box-line',
                                    permission: 'certificatecentercertificate_addlogo',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadEditLogo();
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'certificatecentercertificate_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.$t('certificate_center_id'),
                            field: 'code',
                            hidden: false,
                            formatFn:(col,row)=>{
                                let text ='';
                                text += row.certificate_center.name;
                                return text;
                            },
                        },
                        {
                            label: this.toUpperCase('certificates_name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('start_date'),
                            field: 'start_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('end_date'),
                            field: 'end_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('document_type'),
                            field: this.$i18n.locale=='tr' ? 'document_type_name':'document_type_name_en',
                            hidden: false,
                        },
                        {
                            label: this.toUpperCase('document_draft'),
                            field: 'document_template',
                            hidden: false
                        },
                        // {
                        //     label: this.toUpperCase('content'),
                        //     field: 'content',
                        //     hidden: false
                        // },
                        // {
                        //     label: this.toUpperCase('signer'),
                        //     field: 'signers',
                        //     hidden: false,
                        //     formatFn: (col, row) => {
                        //         if (row.signer_names && Array.isArray(row.signer_names)) {
                        //             return row.signer_names.map(signer => signer.full_name).join(', ');
                        //         } else {
                        //             return '';
                        //         }
                        //     },
                        // },
                        {
                            label: this.toUpperCase('has_teams_integration'),
                            field: 'has_teams_integration',
                            hidden: false,
                            formatFn:(row)=>{
                                return row === true ? this.$t('there_is') : this.$t('absent')
                            }
                        },
                        {
                            label: this.toUpperCase('allow_epayment'),
                            field: 'allow_epayment',
                            hidden: false,
                            formatFn:(row)=>{
                                return row === true ? this.$t('there_is') : this.$t('absent')
                            }
                        },
                        {
                            label: this.toUpperCase('allow_vinov'),
                            field: 'allow_vinov',
                            hidden: false,
                            formatFn:(row)=>{
                                return row === true ? this.$t('there_is') : this.$t('absent')
                            }
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CertificateCenterCertificateService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData() {
                this.formProcess = 'update';
                CertificateCenterCertificateService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            loadSignerData() {
                this.formProcess = 'signerUpdate';
                CertificateCenterCertificateService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateSignerModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            loadOtherSignerData() {
                this.formProcess = 'otherSignerUpdate';
                CertificateCenterCertificateService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateOtherSignerModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            loadEditLogo() {
                this.formProcess = 'logoUpdate';
                CertificateCenterCertificateService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateLogoModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.deleteModal(() => {
                    CertificateCenterCertificateService.deleteCertificate(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateSignerSuccess() {
                this.$refs.updateSignerModal.$refs.commonModal.hide()
            },
            async updateOtherSignerSuccess() {
                this.$refs.updateOtherSignerModal.$refs.commonModal.hide()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
        }
    }
</script>
